import React from "react";
import PropTypes from "prop-types";
import { useDictionary } from "hooks";
import CommentDisplayModal from "components/CommentDisplayModal";
import ModifyFormModal from "containers/Modifications/Modals/ModifyFormModal";
import ActivateModificationModal from "containers/Modifications/Modals/ActivateModificationModal";
import ConfirmationModal from "components/ConfirmationModal";

import styles from "./styles.css";

const ModificationModals = ({
	activateDraftModalData,
	confirmDeleteModalData,
	commentModalData,
	modifyFormModalData,
	isSubaward,
	canReroute,
}) => {
	const commentDictionary = useDictionary("modifications.common.modal.comment");
	const deleteDictionary = useDictionary("modifications.common.modal.delete");
	const { confirmDeleteVisible, onConfirmDelete, onConfirmDeleteClose } = confirmDeleteModalData;
	const { comment, commentTitle, commentVisible, onCommentClose } = commentModalData;
	const { modifyFormModalVisible } = modifyFormModalData;
	const { activateDraftModalVisible } = activateDraftModalData;

	return (
		<>
			{ commentVisible &&
				<CommentDisplayModal
					title={commentTitle || commentDictionary.title || "Modification Comment"}
					comment={comment}
					open={commentVisible}
					onClose={onCommentClose}
				/>
			}
			{modifyFormModalVisible  && <ModifyFormModal modifyFormModalData={modifyFormModalData} isSubaward={isSubaward}/>}
			{ activateDraftModalVisible &&
				<ActivateModificationModal
					activateModalData={activateDraftModalData}
					isSubaward={isSubaward}
					canReroute={canReroute}
				/>
			}
			{ confirmDeleteVisible &&
				<ConfirmationModal
					className={styles.deleteModal}
					cancelButtonLabel={ deleteDictionary.closeLabel || "Close"}
					cancelButtonOptions={{ primary: true }}
					confirmButtonLabel={ deleteDictionary.deleteLable || "Delete Modification"}
					confirmButtonOptions={{ danger: true }}
					icon="trash-alt"
					message={ deleteDictionary.message || "There is no way to restore this modification once it’s deleted. Are you sure you want to delete it?"}
					onConfirm={onConfirmDelete}
					onCancel={onConfirmDeleteClose}
					title={deleteDictionary.title || "Delete Modification" }
					visible={confirmDeleteVisible}
				/>
			}
		</>
	);
};

export default ModificationModals;
